import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  private isEmbedSource = new BehaviorSubject<boolean>(false);
  private isPreviewSource = new BehaviorSubject<boolean>(false);

  setIsEmbed(value: boolean) {
    this.isEmbedSource.next(value);
  }

  getIsEmbed(): boolean {
    return this.isEmbedSource.value;
  }

  setIsPreview(value: boolean) {
    this.isPreviewSource.next(value);
  }

  getIsPreview(): boolean {
    return this.isPreviewSource.value;
  }
}
